
import React from 'react';
import PropTypes from 'prop-types';
import { Col, Grid, Row } from 'react-bootstrap';
import { TextField } from '@material-ui/core/';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import { emphasize } from '@material-ui/core/styles/colorManipulator';
import AsyncSelect from 'react-select/lib/Async';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';
import DatePicker from 'material-ui-pickers/DatePicker';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Vehicle from './Vehicle';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import Banner from './Banner';
import * as moment from 'moment';
import InputMask from 'react-input-mask';
import CircularProgress from '@material-ui/core/CircularProgress';
import AlertDialog from './AlertDialog';
var uniqid = require('uniqid');

//require('es6-promise').polyfill();
//require('isomorphic-fetch');

var makeModelList = require('./make-model-list.json');

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        width: "100%"
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: "100%"
    },
    dense: {
        marginTop: 19
    },
    menu: {
        width: 200
    },
    root: {
        flexGrow: 1,
        height: 250,
    },
    radio: {
        paddingLeft: '6px',
        paddingRight:'6px'
    },
    input: {
        display: 'flex',
        padding: 0,
    },
    loading: {
        margin: '50px auto 0 -20px',
        position: 'relative',
        left:'50%'
    },
    group: {
        margin: `${theme.spacing.unit}px 0`,
        flexDirection:'row'
    },
    valueContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        flex: 1,
        alignItems: 'center',
    },
    chip: {
        margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
    },
    chipFocused: {
        backgroundColor: emphasize(
            theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
            0.08,
        ),
    },
    noOptionsMessage: {
        padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
    },
    singleValue: {
        fontSize: 16,
    },
    placeholder: {
        position: 'absolute',
        left: 2,
        fontSize: 16,
    },
    paper: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing.unit,
        left: 0,
        right: 0,
    },
    divider: {
        height: theme.spacing.unit * 2,
    },
    legend: {
        fontSize: '.75em',
        position: 'relative',
        top:'7px'
    },
    errorMsg: {
        color: '#f44336',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontSize: '.8em',
        margin: '-8px 8px',

        '&:empty': {
            display:'none'
        }
    },
    switchLabel: {
        fontSize: '1rem',
    }
});

function NoOptionsMessage(props) {
    return (
        <Typography
            color="textSecondary"
            className={props.selectProps.classes.noOptionsMessage}
            {...props.innerProps}
        >
           Type to search
        </Typography>
    );
}

function inputComponent({ inputRef, ...props }) {
    return <div ref={inputRef} {...props} />;
}

function Control(props) {
    return (
        <TextField
            fullWidth
            InputProps={{
                inputComponent,
                inputProps: {
                    className: props.selectProps.classes.input,
                    inputRef: props.innerRef,
                    children: props.children,
                    ...props.innerProps,
                },
            }}
            {...props.selectProps.textFieldProps}
        />
    );
}


function Option(props) {
    return (
        <MenuItem
            buttonRef={props.innerRef}
            selected={props.isFocused}
            component="div"
            style={{
                fontWeight: props.isSelected ? 500 : 400,
            }}
            {...props.innerProps}
        >
            {props.children}
        </MenuItem>
    );
}

function Placeholder(props) {
    return (
        <Typography
            color="textSecondary"
            className={props.selectProps.classes.placeholder}
            {...props.innerProps}
        >
            {props.children}
        </Typography>
    );
}

function SingleValue(props) {
    return (
        <Typography className={props.selectProps.classes.singleValue} {...props.innerProps}>
            {props.children}
        </Typography>
    );
}

function ValueContainer(props) {
    return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
}

function Menu(props) {
    return (
        <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
            {props.children}
        </Paper>
    );
}

const components = {
    Control,
    Menu,   
    NoOptionsMessage,
    Option,
    Placeholder,
    SingleValue,
    ValueContainer,
};

const newVehicle = () => {

    return {
        id: uniqid(),      
        color: { id: 'black', name: 'Black' },
        make: '',
        model: ''      
    };
};

var loadOptionsTimeout = null;

const loadOptions = (inputValue, callback) => {

    if ((inputValue || '').length < 3) {
        callback([]);
        return;
    }

    clearTimeout(loadOptionsTimeout);
    loadOptionsTimeout = setTimeout(() => {
        
            fetch('api/DataLookup/QueryAddresses', {
                method: "POST",
                body: JSON.stringify({ 'inputValue': inputValue }),
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                }
            })
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw Error('Network response was not ok.');
                }
            })
            .then(data => {
                callback(data);
            }).catch(error => {
                console.error(error);
            });
    },300);

};

const loadVehicles = (callback) => {
    var vehicles = makeModelList.map(x => {
        return {
            name: x.Name,
            models: x.Models
        };
    });    
    callback(vehicles);       
};

const defaultState = (t) => {
    return {
        creating: false,
        loading: false,
        lightsOnTimers: false,
        petsInHome: false,
        keyholderName: '',
        keyholderPhone: '',
        name: '',
        phone: '',
        addressID: '',
        address: '',
        addressObj: null,
        addressX: null,
        addressY:null,
        reason: '',
        inputValue: '',
        vehicles: [newVehicle()],
        startDate: moment.utc(new Date(), 'YYYY-MM-DD').add(7, 'days').toDate(),
        endDate: moment.utc(new Date(), 'YYYY-MM-DD').add(12, 'days').toDate(),
        vehicleList: t.state && t.state.vehicleList ? t.state.vehicleList : [],
        valid: false,
        errors: [],
        dialog: {
            open: false,
            message: '',
            title: '',
            description: '',
            onOkayClick: () => {
                t.setState(state => {
                    state.dialog.open = false;
                    return state;
                });
            },
            onClose: () => {
                t.setState(state => {
                    state.dialog.open = false;
                    return state;
                });
            }
        }
    };
};


class Home extends React.Component {
    displayName = Home.name;    

    state = { ...defaultState(this) };
    
    componentDidMount() {                
       loadVehicles((data) => {
           this.setState({ vehicleList: data, loading:false });          
        });
    }      

    resetState() {

        this.setState({ ...defaultState(this) }); 
    }

    handleChange = name => event => {

        var value = event.target.value;
        
        if (name === "phone" || name === 'keyholderPhone') {
            value = (event.target.value.match(/\d+/g) || ['']).join('');
        }

        this.setState({
            [name]: value
        }, () => {
            this.validateField(name);
        });
    };

    handleSwitchChange = name => event => {
       
      
        this.setState({ [name]: event.target.checked }, () => {
            this.validateField(name);
        });
    };

    handleSelectChange = name => value => {
      
        this.setState({
            [name]: value,
        }, () => {

            if (name === "addressObj") {
                this.setState({ address: value.label, addressID: value.value, addressGeo:value.geometry}, () => {
                    this.validateField(name);
                });
            } else {
                this.validateField(name);
            }            
        });
    };

    createRequest() {

        var request = {
            name: this.state.name,
            reason: this.state.reason,
            phone: this.state.phone,
            addressID: this.state.addressID,
            address: this.state.address,
            addressX: this.state.addressGeo.x,
            addressY: this.state.addressGeo.y,
            startDate: this.state.startDate,
            endDate: this.state.endDate,
            lightsTimers: this.state.lightsOnTimers,
            keyholderName: this.state.keyholderName,
            keyholderPhone: this.state.keyholderPhone,
            petsHouse: this.state.petsInHome,
            vehicles: this.state.vehicles.map(v => {
                return {
                    Color: v.color.name,
                    Make: v.make,
                    Model: v.model,
                };
            })
        };
                       
        if (this.validateRequest()) {

            this.setState({ creating: true });

            fetch('api/request/create', {
                method: 'POST',
                body: JSON.stringify(request),
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                }
            }).then(response => {               
                if (response.ok) {
                    return response.json();
                } else {
                    throw Error('Network response was not ok.');
                }
            }).then(data => {
                this.setState({ creating: false });


                if (data.error) {
                    //contains error message
                    this.setState({
                        dialog: Object.assign(this.state.dialog, {
                            open: true,
                            title: 'There was a problem with your request',
                            description: data.message
                        })
                    });

                } else {
                    //display thank you
                    this.setState({
                        creating: false,
                        loading:false,
                        dialog: Object.assign(this.state.dialog, {
                            open: true,
                            title: 'Thank You!',
                            description: 'Your vacation watch request has been submitted to the Village of Schaumburg Police Department.  If you need to make any changes or cancellations to this request please contact 847.882.3586 (or dial 311 within Schaumburg) .',
                            onOkayClick: () => {
                                this.setState(state => {
                                    state.dialog.open = false;
                                    return state;
                                }, this.resetState());
                            },
                            onClose: () => {
                                this.setState(state => {
                                    state.dialog.open = false;
                                    return state;
                                }, this.resetState());
                            }
                        })
                    });
                }


            }).catch(error => {
                console.error(error);
                this.setState({
                    creating: false,
                    loading:false,
                    dialog: Object.assign(this.state.dialog, {
                        open: true,
                        title: 'There was a unknown problem with your request',
                        description: 'Something went wrong.  Please try your request again'
                    })
                });
            });

        } else {

            this.setState({
                creating: false,
                loading:false,
                dialog: Object.assign(this.state.dialog, {
                    open: true,
                    title: 'Invalid Request',
                    description:'Please check all fields for valid input'
                })
            });
        }
    }

    validateRequest() {

        var errors = [];

        ["name", "phone", "keyholderName", "keyholderPhone", "addressObj", "startDate", "endDate", "reason"].map(name => {
           return errors.push(this.validateField(name, null, true));
        });

        this.state.vehicles.map(vehicle => {
           return ['make', 'model', 'color'].map(name => {
              return errors.push(this.validateField(name, vehicle, true));
            });
        });


        var valid = true;
        for (var error, i = 0, len = errors.length; i < len; i++) {
            error = errors[i]; 
            for (var e in error) {
                var field = error[e];
               
                if (field) {
                    valid = false;
                    break;
                }
            }
            if (!valid) {
                break;
            }
        }
        return valid;
    }

    fieldTimeout = [];
    validateField(name, vehicle, immediate = false) {
              
        var validate = () => {
            var errors = this.state.errors;

            switch (name) {
                case 'name':

                    errors[name] = null;

                    if (!this.state.name || this.state.name.length < 1) {
                        errors[name] = "Required";

                    } else if (this.state.name && this.state.name.length > 100) {
                        errors[name] = "Max length is 100 characters";

                    } else if (this.state.name && !(/[a-zA-Z]{1,}\s[a-zA-Z]{1,}/gi).test(this.state.name)){
                        errors[name] = "Full name required";
                    }                    
                    break;
                case 'keyholderName':
                    errors[name] = null;
                    if (!this.state.keyholderName || this.state.keyholderName.length < 1) {
                        errors[name] = "Required";

                    } else if (this.state.keyholderName && this.state.keyholderName.length > 100) {
                        errors[name] = "Max length is 100 characters";
                    }
                    break;
                case 'startDate':
                    errors[name] = null;
                    if (!moment(this.state.startDate).isValid()) {                       
                        errors[name] = "Required";
                    }
                    break;
                case 'endDate':
                    errors[name] = null;
                    if (!moment(this.state.endDate).isValid()) {                     
                        errors[name] = "Required";
                    }
                    break;
                case 'phone':
                    errors[name] = null;
                    if (!this.state.phone || this.state.phone.length < 1) {                       
                        errors[name] = "Required";
                    } else if (this.state.phone && this.state.phone.length > 11) {                        
                        errors[name] = "Max length is 10 characters";
                    } else if (this.state.phone && this.state.phone.length < 11) {
                        errors[name] = "Not valid phone number";
                    }

                    break;
                case 'keyholderPhone':
                    errors[name] = null;
                    if (!this.state.keyholderPhone || this.state.keyholderPhone.length < 1) {
                        errors[name] = "Required";
                    } else if (this.state.keyholderPhone && this.state.keyholderPhone.length > 11) {
                        errors[name] = "Max length is 10 characters";
                    } else if (this.state.keyholderPhone && this.state.keyholderPhone.length < 11) {
                        errors[name] = "Not valid phone number";
                    }

                    break;
                case 'addressObj':
                    errors[name] = null;
                    if (!this.state.addressID || this.state.addressID.length < 1) {                       
                        errors[name] = "Required";
                    }

                    if (!this.state.address || this.state.address.length < 1) {                     
                        errors[name] = "Required";
                    }

                    break;
                case 'reason':
                    errors[name] = null;
                    if (this.state.reason && this.state.reason.length > 500) {
                        errors[name] = "Max length is 500 characters";
                    }
                    break;
                case 'make':
                    errors[name + vehicle.id] = null;
                    if (this.state.vehicles.length > 1 && (!vehicle.make || vehicle.make.length < 1)) {
                        //first name is required 
                        errors[name + vehicle.id] = "Required";                      
                    }
                    break;
                case 'model':
                    errors[name + vehicle.id] = null;
                    if (this.state.vehicles.length > 1 && (!vehicle.model || vehicle.model.length < 1)) {
                        //first name is required 
                        errors[name + vehicle.id] = "Required";
                    }
                    break;
                case 'color':
                    errors[name + vehicle.id] = null;
                    if (this.state.vehicles.length > 1 && (!vehicle.color || vehicle.color.name.length < 1)) {
                        //first name is required 
                        errors[name + vehicle.id] = "Required";
                    }

                    break;
                default:
                    //console.log('validation missing for: [' + name + ']');
                    break;
            }

            this.setState({ errors: errors });

            return errors;

        };
        
        if (immediate) {
            return validate();
        } else {
            clearTimeout(this.fieldTimeout[name + (vehicle ? vehicle.id : '')]);
            this.fieldTimeout[name + (vehicle ? vehicle.id : '')] = setTimeout(validate, 300);
        }
    }    

    addVehicle() {
        var vehicles = this.state.vehicles;
        vehicles.push(newVehicle());
        this.setState({ vehicles: vehicles });
    }

    removeVehicle(index) {
        var vehicles = this.state.vehicles;
        var removed = vehicles.splice(index, 1);
        //need to remove any errors from this vehicle
        //ends with vehicle id
        var errors = this.state.errors;
        for (var error in errors) {
            
            if (error.match(removed[0].id)) {
                delete errors[error];
            }
        }
        this.setState({ errors:errors, vehicles: vehicles });
    }

    onVehicleChange(name, vehicle, index) {
        var vehicles = this.state.vehicles;
        vehicles[index].color = vehicle.color;
        vehicles[index].make = vehicle.make;
        vehicles[index].model = vehicle.model;      
        
        this.setState({ vehicles: vehicles }, () => {            
            this.validateField(name, vehicle);
        });
    }
           
    render() {
        const { classes, theme } = this.props;

        const selectStyles = {
            input: base => ({
                ...base,                
                color: theme.palette.text.primary,
                '& input': {
                    font: 'inherit',
                },
            }),
        };

        return (
            <div>
                <Banner working={this.state.creating} onCreate={() => this.createRequest()} disabled={this.state.loading} />


            


                <AlertDialog dialogTitle={this.state.dialog.title} dialogDescription={this.state.dialog.description} open={this.state.dialog.open} onOkayClick={this.state.dialog.onOkayClick} onClose={this.state.dialog.onClose} />

                {this.state.loading && <CircularProgress className={classes.loading} />}
                               

                {!this.state.loading && <Grid className="container" fluid>
                    <Row>
                        <Col sm={6}>
                            <TextField
                                error={!!this.state.errors['name']}
                                id="name"
                                label="Resident Full Name"
                                value={this.state.name}
                                className={classes.textField}
                                onChange={this.handleChange('name')}
                                onBlur={() => this.validateField('name')}
                                margin="normal"
                            />
                            <div className={classes.errorMsg}>{this.state.errors['name']}</div>
                        </Col>
                        <Col sm={6}>
                            <InputMask
                                mask="1 (999) 999 9999"
                                value={this.state.phone}
                                onChange={this.handleChange('phone')}
                                onBlur={() => this.validateField('phone')}
                                className={classes.textField}
                            >
                                {() => (<TextField
                                    error={!!this.state.errors['phone']}
                                    id="phone"
                                    label="Resident Phone"
                                    className={classes.textField}
                                    margin="normal"
                                    type="tel"
                                        />
                                )
                                }
                            </InputMask>
                            <div className={classes.errorMsg}>{this.state.errors['phone']}</div>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <FormControl error={!!this.state.errors['addressObj']} className={classes.formControl} style={{ marginTop: '12px' }}>
                                <AsyncSelect
                                    id="address"                                    
                                    cacheOptions
                                    defaultOptions={[]}
                                    loadOptions={loadOptions}
                                    components={components}
                                    classes={classes}
                                    styles={selectStyles}
                                    value={this.state.addressObj}
                                    onBlur={() =>  this.validateField('addressObj')}
                                    onChange={this.handleSelectChange('addressObj')}
                                    placeholder="Resident Address"
                                    textFieldProps={{
                                        label: 'Resident Address',
                                        InputLabelProps: {
                                            shrink: true,
                                        },
                                    }}
                                />         
                                <div className={classes.errorMsg} style={{ margin: '0', position: 'absolute', bottom:'-16px' }}>{this.state.errors['addressObj']}</div>
                            </FormControl>
                        </Col>
                        <Col sm={6}>
                            <div style={{ display: 'flex', justifyContent: 'space-between',margin:'8px 0 0 0' }}>
                                <div>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <DatePicker
                                            id="startDate"
                                            value={this.state.startDate}
                                            error={!!this.state.errors['startDate']}
                                            className={classes.textField}
                                            style={{ width: "100%", marginTop: '10px' }}
                                            minDate={moment.utc().add(-1, 'd').toDate()}
                                            maxDate={moment.utc().add(6, 'month').toDate()}
                                            label="Start Date"
                                            onBlur={() => this.validateField('startDate')}
                                            onChange={this.handleSelectChange('startDate')}                                          
                                        />
                                    </MuiPickersUtilsProvider>
                                    <div className={classes.errorMsg}>{this.state.errors['startDate']}</div>
                                </div>
                                <div>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <DatePicker
                                            id="endDate"
                                            value={this.state.endDate}
                                            error={!!this.state.errors['endDate']}
                                            className={classes.textField}
                                            style={{ width: "100%", marginTop: '10px' }}
                                            minDate={moment.utc().add(-1, 'd').toDate()}
                                            maxDate={moment.utc().add(9, 'month').toDate()}
                                            label="End Date"
                                            onBlur={() => this.validateField('endDate')}
                                            onChange={this.handleSelectChange('endDate')}
                                        />
                                    </MuiPickersUtilsProvider>
                                    <div className={classes.errorMsg}>{this.state.errors['endDate']}</div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <TextField
                                error={!!this.state.errors['keyholderName']}
                                id="keyholderName"
                                label="Keyholder Name"
                                value={this.state.keyholderName}
                                className={classes.textField}
                                onChange={this.handleChange('keyholderName')}
                                onBlur={() => this.validateField('keyholderName')}
                                margin="normal"
                            />
                            <div className={classes.errorMsg}>{this.state.errors['keyholderName']}</div>
                        </Col>
                        <Col sm={6}>
                            <InputMask
                                mask="1 (999) 999 9999"
                                value={this.state.keyholderPhone}
                                onChange={this.handleChange('keyholderPhone')}
                                onBlur={() => this.validateField('keyholderPhone')}
                                className={classes.textField}
                            >
                                {() => (<TextField
                                    error={!!this.state.errors['keyholderPhone']}
                                    id="keyholderPhone"
                                    label="Keyholder Phone"
                                    className={classes.textField}
                                    margin="normal"
                                    type="tel"
                                />
                                )
                                }
                            </InputMask>
                            <div className={classes.errorMsg}>{this.state.errors['keyholderPhone']}</div>
                        </Col>
                    </Row>

                    <Row style={{margin:'15px 0 0 0'}}>
                        <Col sm={6}>

                            <FormControlLabel
                                classes={{ label: classes.switchLabel }}
                                control={
                                    <Switch
                                        onBlur={() => this.validateField('lightsOnTimers')}
                                        color="primary"
                                        onChange={this.handleSwitchChange('lightsOnTimers')}
                                        checked={this.state.lightsOnTimers}
                                        value={this.state.lightsOnTimers}
                                    />}
                                label="Lights on Timers"
                            />
                            <div className={classes.errorMsg}>{this.state.errors['lightsOnTimers']}</div>
                        </Col>
                        <Col sm={6}>

                            <FormControlLabel
                                classes={{ label: classes.switchLabel }}
                                control={
                                    <Switch
                                        onBlur={() => this.validateField('petsInHome')}
                                        color="primary"
                                        onChange={this.handleSwitchChange('petsInHome')}
                                        checked={this.state.petsInHome}
                                        value={this.state.petsInHome}
                                    />}
                                label="Pets in Home"
                            />
                            <div className={classes.errorMsg}>{this.state.errors['petsInHome']}</div>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={12}>
                            <TextField
                                error={!!this.state.errors['reason']}
                                id="reason"
                                multiline                              
                                label="Special Instructions / Comments (optional)"
                                value={this.state.reason}
                                className={classes.textField}
                                onChange={this.handleChange('reason')}
                                onBlur={() => this.validateField('reason')}
                                margin="normal"
                            />
                            <div className={classes.errorMsg}>{this.state.errors['reason']}</div>
                        </Col>
                    </Row>


                    <div style={{ margin: '20px 0 2px 0' }}>
                        <Typography variant="subtitle1" style={{ color: '#888', fontSize: '1.05em' }}>Vehicles at (or expected at) property</Typography>
                    </div>
                    <Row>
                        <Col sm={12}>
                            {
                                this.state.vehicles.map((vehicle, index) => {
                                    return (
                                        <div key={vehicle.id} style={{ margin: '10px -5px 10px 0px' }}>
                                            <Paper key={'paper' + vehicle.id}>
                                                {index > 0 &&
                                                    <div style={{ display: 'flex' }} key={'heading' + vehicle.id}>

                                                        <div style={{ flex: 1, margin: '15px' }}>
                                                            <Typography variant="h5">
                                                                Vehicle {index + 1}
                                                            </Typography>
                                                        </div>

                                                        <div style={{ textAlign: 'right' }}>
                                                            <IconButton onClick={() => this.removeVehicle(index)} className={classes.button} aria-label="Delete">
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        </div>
                                                    </div>
                                                }
                                                <Vehicle errors={this.state.errors} onBlur={(name,vehicle) => this.validateField(name,vehicle)} onVehicleChange={(name, vehicle) => this.onVehicleChange(name, vehicle, index)} key={vehicle.id} item={vehicle} vehicleList={this.state.vehicleList} />
                                            </Paper>
                                        </div>
                                    );
                                })
                            }
                            <Button disabled={this.state.vehicles.length > 5} onClick={() => this.addVehicle()} variant="outlined" color="primary">
                                {this.state.vehicles.length > 5 ? <span>Maximum number of vehicles reached</span> : <span> Add {this.state.vehicles.length ? 'another' : ''} vehicle </span>}
                            </Button>
                        </Col>
                    </Row>
                </Grid>}                
             </div>
        );
    }
}

Home.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Home);


// WEBPACK FOOTER //
// ./src/components/Home.jsx